import React, {Component} from 'react'
import {
    Card,
    Tooltip,
    Table,
    Button,
    message,
    notification,
    Badge,
    Tag,
    Form,
    Input, Popover, Pagination, Select, DatePicker, Popconfirm
} from 'antd';
import {getDataRightList,getDataRightOptionList,delDataRightItem} from '../../../request'
import * as Icon from '@ant-design/icons';
import moment from "moment";
import './index.less'
let columnsKey = {
    index: '序号',
    bussId: '业务ID',
    bussName: "业务名",
    operation: "操作",
}

export default class DataRight extends Component {
    formRef = React.createRef();
    state = {
        dataSource:[],
        userList:[],
        optionsList:[],
        columns:[],
        loading:false,
        visible:false,
        systemItem:{},
        formParam:{
            pageSize:20,
            pageNum:1
        }
    };
    createColumns = (createKeys)=>{
        let columns = Object.keys(createKeys).map(item=>{
            let initObj = {
                title:createKeys[item],
                dataIndex:item,
                key:item,
                align:'center'
            }
            if(item=='index'){
                return {
                    ...initObj,
                    width:60,
                    fixed: 'left',
                    render:(text,record,index)=>{
                        return index+1
                    }
                }
            }else if(item == 'operation'){
                return  {
                    ...initObj,
                    fixed: 'right',
                    width: 200,
                    render: (text, record, index) => {
                        return (
                            <>
                                <Button type="link" size="small" onClick={() => this.editItem(record)}>编辑</Button>
                                <Popconfirm
                                    title="确定要删除该条数据吗？"
                                    onConfirm={()=>this.deleteItem(record)}
                                    okText="确认"
                                    cancelText="取消"
                                >
                                    <Button type="link" size="small">删除</Button>
                                </Popconfirm>
                            </>
                        )
                    }
                }
            }else{
                return initObj
            }
        })
        this.setState({
            columns,
        })
    }
    initTableDataList(){
        this.setState({ loading: true });
        getDataRightList(this.state.formParam).
        then(res=>{
            this.setState({
                loading: false,
                dataSource:res.list,
                total:res.total
            })
        })
    }
    initOptionDataList(){
        getDataRightOptionList().
        then(res=>{
            this.setState({
                optionsList:[...res]
            })
        })
    }
    handleValueChange = (values,allValues)=>{
        console.log('change',values,allValues)
        let param = {...this.state.formParam}
        let selKeys = Object.keys(values)
        let selValues = Object.values(values)
        console.log('rrr',values,selKeys,selValues,param)
        if(selKeys[0]=='requestTime'){
            param.requestTime = selValues[0]?moment(selValues[0]).format('YYYY-MM-DD HH:mm:ss'):null
        }else if(selKeys[0]=='requestRangeTime'){
            param.start = selValues[0]?moment(selValues[0][0]).format('YYYY-MM-DD HH:mm:ss'):null
            param.end = selValues[0]?moment(selValues[0][1]).format('YYYY-MM-DD HH:mm:ss'):null
        }else{
            param[selKeys[0]] = selValues[0]?selValues[0]:null
        }
        console.log(param)
        this.setState({
            formParam:param
        })

    }
    handleSubmit = (values,allValues)=> {
        console.log(values, allValues)
        let {...otherParam} = {...this.state.formParam}
        console.log(otherParam)
        otherParam.pageNum = 1
        this.setState({
            formParam:otherParam
        })
        this.initTableDataList()
    }
    editItem = (values)=>{
        this.props.history.push({pathname:`/admin/dataRight/${values.id}`})
    }
    deleteItem = (values)=>{
        delDataRightItem({
            id:values.id
        }).
        then(res=>{
            message.success('删除成功')
            this.initTableDataList()
        })
    }
    componentDidMount(){
        this.createColumns(columnsKey);
        this.initTableDataList()
        this.initOptionDataList()
    }
    render() {
        const { dataSource,columns, loading,visible,systemItem} = this.state;
        return (
            <div className='data-right-wrap'>
                <Card title="业务数据管理" bordered={false}>
                    <Form layout="inline" ref={this.formRef}
                          onFinish={this.handleSubmit}
                          onValuesChange={this.handleValueChange}>
                        <Form.Item name="bussId">
                            <Input placeholder="业务ID" />
                        </Form.Item>
                        <Form.Item name={'bussName'}>
                            <Select
                                style={{width: '180px'}}
                                showSearch
                                optionFilterProp="children"
                                fieldNames={{
                                    label: 'Name',
                                    value: 'id'
                                }}
                                filterOption={(input, option) => {
                                    let searchText = option?.Name ?? ''
                                    return searchText.toLowerCase().includes(input.toLowerCase())
                                }
                                }
                                allowClear
                                placeholder="请选择业务名"
                                options={this.state.optionsList}
                                onChange={this.handleUserChange}
                            />
                        </Form.Item>
                        <Form.Item>
                            <Button type="primary" htmlType="submit">查询</Button>
                        </Form.Item>
                        <Form.Item>
                            <Button type="primary" danger={ true} onClick={()=>this.editItem({id:0})}>新增</Button>
                        </Form.Item>
                    </Form>
                    <Table
                        bordered
                        size="small"
                        pagination={false}
                        dataSource={dataSource}
                        rowKey="id"
                        columns={columns}
                        loading={loading}/>
                    <div style={{display:'flex',justifyContent:'flex-end',margin:'20px 0'}}>
                        <Pagination size="small"
                                    hideOnSinglePage={true}
                                    current={this.state.formParam.pageNum}
                                    pageSize={this.state.formParam.pageSize}
                                    total={this.state.total}
                                    showSizeChanger
                                    onChange={(page, pageSize)=>{
                                        console.log(page, pageSize)
                                        let param = this.state.formParam
                                        param.pageSize = pageSize
                                        param.pageNum = page
                                        this.setState({
                                            formParam:{...param}
                                        })
                                        this.initTableDataList()
                                    }}
                        />

                    </div>
                </Card>
            </div>

        )
    }
}